<template>
  <app-data-editor
    :id="id ? id : '0'"
    :title="title || ''"
    resource="shipment-requests"
    need-server-init
    :elements="elements"
    add-message="Запрос добавлен"
    edit-message="Версия добавлена"
    :is-notification="id ? true : null"
    :is-event-cancel="true"
    :hide-id="true"
    :without-remove="true"
    flat
    class="pa-0"
    @save="save"
    @cancel="cancel"
    @saveWithNotification="saveWithNotification"
  />
</template>

<script>
export default {
  props: ["id", "title"],
  data() {
    return {
      date: "28-03-2018",
      elements: [
        [
          {
            title: "Дата",
            name: "date",
            control: {
              type: "date",
              readonly: true,
              required: true,
            },
          },
          {
            title: "Клиент",
            name: "client",
            control: {
              type: "reference",
              component: "Client",
              resource: "clients",
              autoSetChildren: "Manager",
              autoSetChildrenField: "employee",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Менеджер",
            name: "employee",
            control: {
              type: "manager-select",
              component: "Employee",
              resource: "employees",
              assignClientManager: true,
              required: true,
              rules: [v => !!v || ""],
            },
          },
        ],
        [
          {
            title: "Страна отправления",
            name: "sendingCountry",
            control: {
              type: "reference",
              component: "Country",
              resource: "countries",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Производитель",
            name: "manufacturer",
            control: {
              type: "reference",
              component: "Manufacturer",
              resource: "manufacturers",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Продавец",
            name: "factory",
            control: {
              type: "reference",
              component: "Factory",
              resource: "factories",
              required: true,
              rules: [v => !!v || ""],
            },
          },
        ],
        [
          {
            title: "Регион",
            name: "region",
            control: {
              type: "reference",
              component: "Region",
              resource: "regions",
              parentField: "sendingCountry",
              parentFilter: "countryId",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Адрес погрузки",
            name: "loadingAddress",
            control: {
              type: "reference",
              component: "Address",
              resource: "addresses",
              parentField: "region",
              parentFilter: "regionId",
              required: true,
              rules: [v => !!v || ""],
            },
          },
        ],
        [
          {
            title: "Категория товара",
            name: "productCategory",
            control: {
              type: "reference",
              component: "ProductCategory",
              resource: "product-categories",
            },
            default: "",
          },
          {
            title: "Общее описание товара",
            name: "GeneralProductDescription",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
        ],
        [
          {
            title: "Материал товара",
            name: "productMaterial",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
          {
            title: "Сфера применения",
            name: "usingSphere",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
        ],
        [
          {
            title: "Сайт товара",
            name: "productSite",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
          {
            title: "Страна получателя по докам фабрики/отправителя",
            name: "destinationCountry",
            control: {
              type: "reference",
              component: "Country",
              resource: "countries",
              required: true,
              rules: [v => !!v || ""],
            },
          },
        ],
        [
          {
            title: "Страна выгрузки",
            name: "unloadingCountry",
            control: {
              type: "reference",
              component: "Country",
              resource: "countries",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Город выгрузки",
            name: "unloadingCity",
            control: {
              type: "reference",
              component: "City",
              resource: "cities",
              parentField: "unloadingCountry",
              parentFilter: "countryId",
              required: true,
              rules: [v => !!v || ""],
            },
          },
        ],
        [
          {
            title: "Адрес выгрузки",
            name: "unloadingAddress",
            control: {
              type: "reference",
              component: "Address",
              resource: "addresses",
              parentField: "unloadingCity",
              parentFilter: "cityId",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Тип поставки",
            name: "shippingType",
            control: {
              type: "enum",
              resource: "delivery-types",
              required: true,
              rules: [v => !!v || ""],
              ojectType: true,
            },
          },
        ],
        [
          {
            title: "Дата готовности к отгрузке",
            name: "readyDate",
            control: {
              type: "date",
              required: true,
            },
          },
          {
            title: "Желаемая дата доставки к месту выгрузки",
            name: "wantedDate",
            control: {
              type: "date",
              required: true,
            },
          },
        ],
        [
          {
            name: "packages",
            control: {
              type: "packages",
            },
            default: [],
          },
        ],
        [
          {
            title: "Комментарии к размерам и кол-ву грузовых мест",
            name: "cargoComment",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
        ],
        [
          {
            title: "Объем, м3",
            name: "volume",
            control: {
              type: "text",
              required: true,
              rules: [
                v => !!v || "Поле обязательно к заполнению",
                value => {
                  const pattern = /(^\d+(?:[.][0-9]{1,3})|^\d*)$/g;
                  return (
                    pattern.test(value) ||
                    "Неверно введено значение. Допускается не больше 3-х знаков после точки"
                  );
                },
              ],
            },
            default: "",
          },
          {
            title: "Вес брутто, кг",
            name: "brutto",
            control: {
              type: "text",
              required: true,
              rules: [
                v => !!v || "Поле обязательно к заполнению",
                value => {
                  const pattern = /(^\d+(?:[.][0-9]{1,3})|^\d*)$/g;
                  return (
                    pattern.test(value) ||
                    "Неверно введено значение. Допускается не больше 3-х знаков после точки"
                  );
                },
              ],
            },
            default: "",
          },
        ],
        [
          {
            title: "Сумма инвойса",
            name: "invoiceSum",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
          {
            title: "Валюта",
            name: "currency",
            control: {
              type: "reference",
              component: "Currency",
              resource: "currencies",
              required: true,
              rules: [v => !!v || ""],
            },
            default: "",
          },
          {
            title: "Нужна ли Ex",
            name: "needEx",
            control: {
              type: "enum",
              resource: "need-ex-types",
              required: true,
              rules: [v => !!v || ""],
              ojectType: true,
            },
          },
        ],
      ],
    };
  },
  methods: {
    save(data) {
      this.$emit("save", data);
    },
    cancel() {
      this.$emit("cancel");
    },
    saveWithNotification() {
      this.$emit("saveWithNotification");
    },
  },
};
</script>
